module.exports = __webpack_public_path__ + "assets/img/xuYan.7567d8ff.png";